import * as UrlList from "./network/urlList";

const token = localStorage.getItem("course-tool-token");

/** * 默认环境
 * 开发环境 dev
 * 测试环境 test
 * 测试环境无版本 testSyncProd
 * 预发布版本 pre
 * 正式版本 prod
 ** */
let env = 'test' // 本地调试正式环境 例如手动设置env='pre',即本地调试正式服

const hostname = window.location.hostname
if (hostname === 'localhost' || hostname.startsWith('192')) {
  env = env || 'dev'
} else if (hostname === 'editor.courseware.yunkeduntest.com') {
  env = 'test'
} else if (hostname === 'editor.courseware.yunkedun.com') {
  env = 'prod'
}

const devConfig = {
  isTest:1,
  isDev: false,
  client_id: 2,
  cocos_web: '',
  domain: 'localhost',
  imeditMain: 'http://localhost:8080/main',
  imeditPreview: 'http://localhost:8080/preview',
  ppt_web: 'yunkeduntest.com',
  wx_web: 'https://h5.yunkeduntest.com/wx_luyin/dist/#/',
  shareWeb: 'https://localhost:8080/share',
  courseware: 'https://management.courseware.yunkeduntest.com',
  token,
  ...UrlList.devPublicUrl, // 根据不同环境加载不同URL组
};

const testConfig = {
  isTest:1,
  isDev: false,
  client_id: 11,
  cocos_web: '',
  domain: 'yunkeduntest.com',
  imeditMain: 'https://editor.courseware.yunkeduntest.com/main',
  imeditPreview: 'https://editor.courseware.yunkeduntest.com/preview',
  wx_web: 'https://h5.yunkeduntest.com/wx_luyin/dist/#/',
  shareWeb: 'https://editor.courseware.yunkeduntest.com/share',
  courseware: 'https://management.courseware.yunkeduntest.com',
  token,
  ...UrlList.testPublicUrl, // 根据不同环境加载不同URL组
};

const prodConfig = {
  isTest:0,
  isDev: false,
  client_id: 11,
  cocos_web: '',
  domain: 'yunkedun.com',
  imeditMain: 'https://editor.courseware.yunkedun.com/main',
  imeditPreview: 'https://editor.courseware.yunkedun.com/preview',
  wx_web: 'https://h5.yunkedun.com/wx_luyin/dist/#/',
  shareWeb: 'https://editor.courseware.yunkedun.com/share',
  courseware: 'https://management.courseware.yunkedun.com',
  token,
  ...UrlList.prodPublicUrl, // 根据不同环境加载不同URL组
};

const preConfig = {
  isTest:1,
  isDev: false,
  client_id: 11,
  cocos_web: '',
  domain: 'yunkedun.com',
  imeditPreview: 'http://localhost:8080/preview',
  wx_web: 'https://h5.yunkedun.com/wx_luyin/dist/#/',
  shareWeb: 'https://editor.courseware.yunkedun.com/share',
  token,
  ...UrlList.prodPublicUrl, // 根据不同环境加载不同URL组
};

// 根据环境配置不同的配置
const conf =
  env === "dev"
    ? devConfig
    : env === "test" || env === "testSyncProd"
      ? testConfig
      : env === "prod"
        ? prodConfig
        : env === "pre"
          ? preConfig
          : null;
export default conf;
